import React from 'react';
import { Divider, Menu } from '@mantine/core';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppStack from './AppStack';

const MenuContentActionsList = ({ actions, onAction, data }) => {
  const sections = [...new Set(actions.map((a) => a.section))];

  const renderMenuItem = (a) => {
    const link = a.getLink && data ? a.getLink(data) : a.link;

    return (
      <Menu.Item
        key={a.value}
        component={link ? Link : null}
        leftSection={a.icon}
        onClick={
          link
            ? null
            : (e) => {
                e.preventDefault();
                onAction(a.value, a);
              }
        }
        style={{ color: a.color ?? '#000' }}
        to={link}
      >
        {a.label}
      </Menu.Item>
    );
  };

  return (
    actions.length > 0 &&
    (sections.length > 1 ? (
      sections.map((s, i) => {
        const items = actions.filter((a) => a.section === s);

        return (
          <React.Fragment key={items[0].value}>
            {i > 0 && <Divider />}
            <AppStack style={{ padding: 2, gap: 1 }}>
              {items.map((a) => renderMenuItem(a))}
            </AppStack>
          </React.Fragment>
        );
      })
    ) : (
      <AppStack style={{ padding: 2, gap: 1 }}>
        {actions.map((a) => renderMenuItem(a))}
      </AppStack>
    ))
  );
};

MenuContentActionsList.propTypes = {
  actions: PropTypes.array,
  data: PropTypes.object,
  onAction: PropTypes.func
};

export default MenuContentActionsList;
